import { Component, Input, Output, EventEmitter, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy }  from '@angular/core';
import { FormGroup, FormBuilder, FormControl }     from '@angular/forms';
import { PriceLevel, Price, Money, TicketFee } from '../../models';
import { PriceApi, HttpClient }   from '../../services/webservice';
import { FeeCollection } from "../../models/ui"

@Component({
	selector: 'price-form',
	templateUrl: "./price-form.html",
	providers: [PriceApi, HttpClient],
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./price-form.scss")]
})

export class PriceForm implements AfterViewInit {
	showAccessCodePopup: boolean = false;
	formGroup: FormGroup;
	public randomId: number = Math.floor(Math.random() * 1000000);
	@Input() showFees: boolean;
	@Output() public priceLevelChange = new EventEmitter<PriceLevel>();
	@Output() public deleteClicked = new EventEmitter<void>();
	@Input() deleteable: boolean = false;
	@Input() canBeHiddenOnline = false;
	@Input() canBeSponsorPrice = false;

	_canEditSponsorPrice: boolean = false

	protected feeCollection: FeeCollection

	private priceInclFees: number = 0;
	private _priceLevel;
	private _priceLevelPosition: number = null;
	private lastEmmitedPriceLevel: PriceLevel;
	private disableFormSponsorPrice = null

	constructor(private changeDetectorRef: ChangeDetectorRef, fb: FormBuilder) {
		this.formGroup = fb.group({
			"price": "",
			"name": "",
			"maxAllowed": "",
			"hideOnline": false,
			"voucherNeeded": false,
			"forSponsors": false,
			"pos": null,
		});
	}
	@Input() set canEditSponsorPrice(canEditSponsorPrice){
		if (canEditSponsorPrice) {
			this._canEditSponsorPrice = true
		}
	}

	@Input() set priceLevel(priceLevel: PriceLevel) {
		this.feeCollection = this.createFeeCollection(priceLevel.ticketFees)
		this._priceLevel = priceLevel;
		this.lastEmmitedPriceLevel = this.priceLevel;
		this.updatetPriceInclFees();
		(<FormControl>this.formGroup.controls["price"]).setValue(this.priceLevel.price.money.value);
		(<FormControl>this.formGroup.controls["name"]).setValue(this.priceLevel.name);
		(<FormControl>this.formGroup.controls["maxAllowed"]).setValue(this.priceLevel.maxAllowed);
		(<FormControl>this.formGroup.controls["hideOnline"]).setValue(this.priceLevel.hideOnline);
		(<FormControl>this.formGroup.controls["forSponsors"]).setValue(this.priceLevel.forSponsors);
		(<FormControl>this.formGroup.controls["voucherNeeded"]).setValue(this.priceLevel.voucherNeeded);
		(<FormControl>this.formGroup.controls["pos"]).setValue(this.priceLevelPosition);
	}

	@Input()
	set priceLevelPosition(val: number) {
		this._priceLevelPosition = val;
		if (val != null) {
			(<FormControl>this.formGroup.controls["pos"]).setValue(val);
		}
	}

	get priceLevel() {
		return this._priceLevel;
	}

	get priceLevelPosition(): number {
		return this._priceLevelPosition;
	}

	public isValid(): boolean {
		return this.formGroup.valid;
	}

	public ngOnInit() {
		if (this.canBeSponsorPrice && !this._canEditSponsorPrice && this.formGroup.controls['forSponsors'].value) {
			this.disableFormSponsorPrice = true
		}
	}

	public ngAfterViewInit() {
		this.formGroup.valueChanges.debounceTime(300).subscribe((newVal) => {
			const money = new Money();
			money.value = this.parseNumber(newVal["price"]);
			money.currency = "EUR";
			const newPrice = Object.assign({}, this.priceLevel.price, {
				money: money
			})
			const newPriceLevel = Object.assign({}, this.lastEmmitedPriceLevel, {
				name: newVal["name"],
				price: newPrice,
				hideOnline: newVal["hideOnline"],
				maxAllowed: newVal["maxAllowed"],
				forSponsors: newVal["forSponsors"],
				voucherNeeded: newVal["voucherNeeded"],
				pos: newVal["pos"]
			})
			this.lastEmmitedPriceLevel = newPriceLevel;
			this.priceLevelChange.emit(newPriceLevel)
			this.updatetPriceInclFees();
		});

		/** We need to set the (first) Value of 'pos' in the formGroup after we have subscribed on
		 * formGroup.valueChanges (the first pos-value change does not affect the subscription because of ngAfterViewInit)
		 */
		if (this.priceLevelPosition != null) {
			(<FormControl>this.formGroup.controls["pos"]).setValue(this.priceLevelPosition);
		}
	}

	toggleShowAccessCodePopup() {
		this.showAccessCodePopup = !this.showAccessCodePopup;
	}

	protected createFeeCollection(fees: TicketFee[]) {
		let collection = FeeCollection.create();
		return FeeCollection.fromTicketFeeList(collection, fees);
	}

	protected feeCollectionChange(feeCollection: FeeCollection) {
		const newTicketFees = FeeCollection.toList(feeCollection);
		const newPriceLevel = Object.assign({}, this.lastEmmitedPriceLevel, {
			ticketFees: newTicketFees
		})

		this.lastEmmitedPriceLevel = newPriceLevel;
		this.priceLevelChange.emit(newPriceLevel)
		this.updatetPriceInclFees();

	}

	private updatetPriceInclFees() {
		let fee = this.lastEmmitedPriceLevel.ticketFees.map(ticketFee => ticketFee.fee.value).reduce((a, b) => a + b, 0);
		let price = this.lastEmmitedPriceLevel.price.money.value || 0
		this.priceInclFees = fee + price
		this.changeDetectorRef.markForCheck();

	}

	private parseNumber(str: string) {
		let numberStr = str;
		if (str && str.replace)
			numberStr = str.replace("," , ".");
		return parseFloat(numberStr)
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/price-form/price-form.component.ts